<template>
  <div id="empty">
    <img src="@/assets/empty.png" alt="" />
    <p>You don’t have any record now</p>
    <common-btn class="btn" :click="to">Apply Now</common-btn>
  </div>
</template>

<script>
export default {
  name: 'empty',
  data () {
    return {}
  },
  methods: {
    to () {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped lang="less">
#empty {
  margin-top: 2.2rem;
  img {
    width: 90px;
    height: 98px;
  }
  p {
    font-weight: 500;
    font-size: 14px;
    color: #12033a;
    margin-top: 16px;
    margin-bottom: 50px;
  }
  .btn {
    width: 327px;
  }
}
</style>
